import React from 'react'
import { StoreWrap, config as _c, Block, app, api, use } from 'xadmin'
import { Layout } from 'antd'
import { C } from 'xadmin-ui'

const LoginNextPage = ({ location: { query } }) => {

  const DashboardView = C('DashboardView')
  const DashboardNormalView = C('DashboardNormalView')
  const { settings } = use('settings')
  let isShow = false
  React.useEffect(() => {
    const rectption_login_next_page_hangtime = _c('isMobile') ? (settings?.mobilePage?.rectption_login_next_page_hangtime) : (settings?.rectption_login_next_page_hangtime || settings?.customPage?.rectption_login_next_page_hangtime)
    const hangtime = rectption_login_next_page_hangtime ? rectption_login_next_page_hangtime * 1000 : null
    setTimeout(() => app.go(query && query.redirect || '/app/'), hangtime || 5000)
  }, [])
  if(_c('isMobile')){
    isShow = !!settings?.mobilePage?.rectption_login_next_page?.id
  } else {
    isShow = !!(settings?.rectption_login_next_page?.id || settings?.customPage?.rectption_login_next_page?.id)
  }
  return isShow ? (
    <Layout className="layout layout-full" style={{ minHeight: '100vh' }}>
      <Layout.Content className="main-content">
        <DashboardView params={{ id: _c('isMobile') ? settings?.mobilePage?.rectption_login_next_page?.id : (settings?.rectption_login_next_page?.id || settings?.customPage?.rectption_login_next_page?.id) }} >
          <DashboardNormalView />
        </DashboardView>
      </Layout.Content>
    </Layout>
  ) : null
}

export default {
  routers: {
    '/': [
      {
        path: 'login_next',
        component: LoginNextPage
      },
    ]
  },
}
